import React, { useState } from "react";
import "../../styles/Faq/faq.css"; // Ensure this path matches your file structure

const FAQSection = () => {
  // State to track which question is currently open (null = all closed)
  const [activeId, setActiveId] = useState(null);

  // Toggle function
  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Updated Data based on your image
  const faqData = [
    {
      id: 1,
      question: "Who can join Madhi Academy’s training programs?",
      answer:"Our courses are open to school students (from 8th standard onwards), college students, job seekers, and working professionals." },
    {
      id: 2,
      question: "Do I need prior knowledge to enroll?",
      answer: "No. We offer beginner-friendly programs in computer basics, English, and ERP. You can start fresh and grow step by step.",
    },
     {
      id: 3,
      question: "What is the duration of the courses?",
      answer: "We have both short-term and long-term training options, depending on the course and your learning goals.",
    },
     {
      id: 4,
      question: "Are the classes online or offline?",
      answer: "Currently, classes are conducted at our Chennai campus with flexible weekday and weekend batches.",
    },
     {
      id: 5,
      question: "Do you provide certificates after course completion?",
      answer: "Yes. Students receive a course completion certificate, which helps in resumes, interviews, and job applications.",
    },
     {
      id: 6,
      question: "Is there installment payment available for fees?",
      answer: "Yes. We provide affordable fees with easy installment options to support all learners.",
    }
  ];

  return (
    <section className="faq-section  py-5">
      <div className="container ml-5 mr-5">
        {/* Title Section with Purple Bar */}
        <div
          className="d-flex align-items-center mb-5"
          style={{ marginLeft: "0" }}
        >
          {/* Removed huge left margin to align standardly, or keep '8%' if desired */}
          <div className="title-bar me-3"></div>
          <h2 className="fw-bold text-dark m-0">Frequently Asked Questions</h2>
        </div>

        {/* FAQ List */}
        <div className="row">
          <div className="col-12">
            {faqData.map((item) => (
              <div
                key={item.id}
                className={`faq-item mb-3 ${
                  activeId === item.id ? "active" : ""
                }`}
                onClick={() => toggleFAQ(item.id)}
              >
                {/* Question Header */}
                <div className="faq-header d-flex justify-content-between align-items-center p-3 cursor-pointer">
                  <h6
                    className={`m-0 fw-semibold ${
                      activeId === item.id ? "text-purple" : "text-dark"
                    }`}
                  >
                    {item.question}
                  </h6>
                  {/* Icon switches between Up and Down chevron */}
                  <i
                    className={`bi bi-chevron-${
                      activeId === item.id ? "up" : "down"
                    } transition-icon ${
                      activeId === item.id ? "text-purple" : ""
                    }`}
                  ></i>
                </div>

                {/* Answer Body (Collapsible) */}
                <div
                  className={`faq-body ${activeId === item.id ? "show" : ""}`}
                >
                  <div className="p-3 pt-0 text-muted small lh-lg">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
